import { round as o } from "./math.js";
var H = function H(t) {
    return T(i(t));
  },
  i = function i(t) {
    return t[0] === "#" && (t = t.substring(1)), t.length < 6 ? {
      r: parseInt(t[0] + t[0], 16),
      g: parseInt(t[1] + t[1], 16),
      b: parseInt(t[2] + t[2], 16),
      a: t.length === 4 ? o(parseInt(t[3] + t[3], 16) / 255, 2) : 1
    } : {
      r: parseInt(t.substring(0, 2), 16),
      g: parseInt(t.substring(2, 4), 16),
      b: parseInt(t.substring(4, 6), 16),
      a: t.length === 8 ? o(parseInt(t.substring(6, 8), 16) / 255, 2) : 1
    };
  },
  f = function f(t) {
    return I(b(t));
  },
  p = function p(_ref) {
    var t = _ref.h,
      s = _ref.s,
      n = _ref.v,
      c = _ref.a;
    var r = (200 - s) * n / 100;
    return {
      h: o(t),
      s: o(r > 0 && r < 200 ? s * n / 100 / (r <= 100 ? r : 200 - r) * 100 : 0),
      l: o(r / 2),
      a: o(c, 2)
    };
  },
  d = function d(t) {
    var _p = p(t),
      s = _p.h,
      n = _p.s,
      c = _p.l;
    return "hsl(".concat(s, ", ").concat(n, "%, ").concat(c, "%)");
  },
  b = function b(_ref2) {
    var t = _ref2.h,
      s = _ref2.s,
      n = _ref2.v,
      c = _ref2.a;
    t = t / 360 * 6, s = s / 100, n = n / 100;
    var r = Math.floor(t),
      a = n * (1 - s),
      u = n * (1 - (t - r) * s),
      l = n * (1 - (1 - t + r) * s),
      e = r % 6;
    return {
      r: o([n, u, a, a, l, n][e] * 255),
      g: o([l, n, n, u, a, a][e] * 255),
      b: o([a, a, l, n, n, u][e] * 255),
      a: o(c, 2)
    };
  },
  g = function g(t) {
    var s = t.toString(16);
    return s.length < 2 ? "0" + s : s;
  },
  I = function I(_ref3) {
    var t = _ref3.r,
      s = _ref3.g,
      n = _ref3.b,
      c = _ref3.a;
    var r = c < 1 ? g(o(c * 255)) : "";
    return "#" + g(t) + g(s) + g(n) + r;
  },
  T = function T(_ref4) {
    var t = _ref4.r,
      s = _ref4.g,
      n = _ref4.b,
      c = _ref4.a;
    var r = Math.max(t, s, n),
      a = r - Math.min(t, s, n),
      u = a ? r === t ? (s - n) / a : r === s ? 2 + (n - t) / a : 4 + (t - s) / a : 0;
    return {
      h: o(60 * (u < 0 ? u + 6 : u)),
      s: o(r ? a / r * 100 : 0),
      v: o(r / 255 * 100),
      a: c
    };
  };
export { H as hexToHsva, i as hexToRgba, f as hsvaToHex, d as hsvaToHslString, p as hsvaToHsla, b as hsvaToRgba, I as rgbaToHex, T as rgbaToHsva };